<template>
  <div>Order Complete</div>
</template>

<script>
export default {
  name: "orderComplete"
}
</script>

<style scoped>

</style>